import { render, staticRenderFns } from "./combatAT_index.vue?vue&type=template&id=602223cb&scoped=true"
import script from "./combatAT_index.vue?vue&type=script&lang=js"
export * from "./combatAT_index.vue?vue&type=script&lang=js"
import style0 from "./combatAT_index.vue?vue&type=style&index=0&id=602223cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602223cb",
  null
  
)

export default component.exports